import { useState } from "react";
import {
  Church,
  Users,
  HeartHandshake,
  HandHeart,
  CalendarDays,
  NotebookPen,
  Mic,
  Package,
  Droplets,
  ClipboardCheck,
  UserRound,
  FileBarChart2,
  LayoutGrid,
  Layers,
  X,
  Megaphone,
  Trophy,
  MessageSquare,
  BookText,
} from "lucide-react";

const STORAGE_KEY = "keves:onboarding:done";

const SECTIONS = [
  {
    icon: LayoutGrid,
    title: "Pastoral diario",
    modules: [
      { icon: Church,         label: "Iglesias",           sub: "Congregaciones",       color: "text-indigo-500 dark:text-indigo-300"  },
      { icon: Users,          label: "Hogares y personas", sub: "Familias y miembros",  color: "text-emerald-500 dark:text-emerald-400" },
      { icon: HeartHandshake, label: "Visitas",             sub: "Seguimiento pastoral", color: "text-blue-600 dark:text-blue-400"       },
      { icon: HandHeart,      label: "Oraciones",           sub: "Peticiones activas",   color: "text-rose-500 dark:text-rose-300"       },
      { icon: CalendarDays,   label: "Agenda",              sub: "Eventos y reuniones",  color: "text-blue-400 dark:text-blue-300"       },
      { icon: NotebookPen,    label: "Notas",               sub: "Memoria pastoral",     color: "text-violet-500 dark:text-violet-300"   },
    ],
  },
  {
    icon: Layers,
    title: "Recursos y administración",
    modules: [
      { icon: Mic,            label: "Predicación",             sub: "Roles y mensajes",         color: "text-purple-400 dark:text-purple-300"  },
      { icon: Package,        label: "Materiales",              sub: "Recursos y stock",         color: "text-stone-500 dark:text-stone-400"    },
      { icon: Droplets,       label: "Bautismos",               sub: "Candidatos",               color: "text-cyan-500 dark:text-cyan-400"      },
      { icon: ClipboardCheck, label: "Revisión mensual",        sub: "Seguimiento mensual",      color: "text-teal-500 dark:text-teal-400"      },
      { icon: UserRound,      label: "Equipo Distrital",        sub: "Pastores y líderes",       color: "text-indigo-400 dark:text-indigo-300"  },
      { icon: FileBarChart2,  label: "Reportes Distritales",    sub: "Análisis y documentación", color: "text-[#1b4f9c] dark:text-blue-400"     },
      { icon: Megaphone,      label: "Anuncios",                sub: "Comunicados al distrito",  color: "text-amber-500 dark:text-amber-400"    },
      { icon: Trophy,         label: "Reto Semanal",            sub: "Desafíos para miembros",   color: "text-amber-500 dark:text-amber-400"    },
      { icon: MessageSquare,  label: "Mensajes",                sub: "De miembros al portal",    color: "text-sky-500 dark:text-sky-400"        },
      { icon: Users,          label: "Grupos Pequeños",         sub: "Evangelismo y crecimiento",color: "text-emerald-600 dark:text-emerald-400"},
      { icon: BookText,       label: "Sermones",                sub: "Planificador de mensajes", color: "text-violet-500 dark:text-violet-400"  },
    ],
  },
];

export default function WelcomeBanner() {
  const [visible, setVisible] = useState(
    () => !localStorage.getItem(STORAGE_KEY)
  );

  if (!visible) return null;

  function handleDismiss() {
    localStorage.setItem(STORAGE_KEY, "1");
    setVisible(false);
  }

  return (
    <div className="px-4 pt-4 pb-2">
      <div className="bg-white dark:bg-slate-800 rounded-[24px] border border-slate-200/50 dark:border-slate-700/60 shadow-[0_2px_12px_rgba(0,0,0,0.03)] overflow-hidden">

        {/* Header */}
        <div className="px-5 pt-5 pb-4 flex items-start justify-between gap-3">
          <div>
            <p className="text-[11px] font-bold uppercase tracking-wider text-[#1b4f9c] dark:text-blue-400 mb-1">
              Bienvenido a Kéves
            </p>
            <h2 className="text-[17px] font-semibold text-slate-800 dark:text-slate-100 leading-snug">
              Todo lo que necesitas para gestionar tu distrito
            </h2>
          </div>
          <button
            onClick={handleDismiss}
            className="h-8 w-8 shrink-0 flex items-center justify-center rounded-full bg-slate-100 dark:bg-slate-700 text-slate-400 dark:text-slate-500 active:opacity-70 transition-opacity mt-0.5"
            aria-label="Cerrar"
          >
            <X size={14} />
          </button>
        </div>

        {/* Sections */}
        <div className="px-5 pb-5 space-y-5">
          {SECTIONS.map((section) => {
            const SectionIcon = section.icon;
            return (
              <div key={section.title}>
                <div className="flex items-center gap-1.5 mb-3">
                  <SectionIcon size={12} className="text-slate-400 dark:text-slate-500 shrink-0" />
                  <span className="text-[10px] font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500">
                    {section.title}
                  </span>
                </div>
                <div className="grid grid-cols-2 gap-2">
                  {section.modules.map((mod) => {
                    const Icon = mod.icon;
                    return (
                      <div
                        key={mod.label}
                        className="flex items-center gap-2.5 bg-slate-50 dark:bg-slate-700/40 rounded-[14px] px-3 py-2.5"
                      >
                        <div className="shrink-0 h-7 w-7 rounded-[9px] bg-white dark:bg-slate-700 flex items-center justify-center shadow-[0_1px_4px_rgba(0,0,0,0.06)]">
                          <Icon size={13} className={mod.color} />
                        </div>
                        <div className="min-w-0">
                          <p className="text-[12px] font-semibold text-slate-700 dark:text-slate-200 leading-none truncate">
                            {mod.label}
                          </p>
                          <p className="text-[10px] text-slate-400 dark:text-slate-500 mt-0.5 leading-none truncate">
                            {mod.sub}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="px-5 pb-5">
          <button
            onClick={handleDismiss}
            className="w-full h-11 rounded-[14px] bg-[#1b4f9c] text-white text-[14px] font-semibold shadow-[0_4px_12px_rgba(27,79,156,0.2)] hover:shadow-[0_6px_16px_rgba(27,79,156,0.3)] active:scale-[0.98] active:opacity-80 transition-all duration-200 ease-out"
          >
            Entendido — comenzar
          </button>
        </div>

      </div>
    </div>
  );
}
